import { SectionHead, FadeUp } from "./Reveal";

export const Retreat = () => (
  <section id="retreat" className="relative py-24 lg:py-32 overflow-hidden" data-testid="retreat-section">
    <div className="spotlight pointer-events-none absolute -top-32 right-[-10%] h-[34rem] w-[34rem] rounded-full" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
      <div className="lg:order-2">
        <SectionHead
          eyebrow="Nseya Wellness — a separate chapter"
          title={<>And when the world gets loud… <em className="italic text-gold">Zanzibar</em>.</>}
        />
        <FadeUp>
          <p className="mt-6 text-mute text-base sm:text-lg leading-relaxed">
            Before there was a quote to write, there was an ocean.{" "}
            <span className="text-ivory">Nseya Wellness</span> is Ariane's separate retreat
            experience — six nights in Zanzibar where the Indian Ocean sets the rhythm: safari
            at dawn, turquoise water, sacred ceremony, and a body that finally feels like home.
          </p>
        </FadeUp>
        <FadeUp delay={0.05}>
          <p className="mt-4 text-mute text-base sm:text-lg leading-relaxed">
            A different kind of reset — same hands, same heart. Warmly inviting, quietly
            transformative, and unlike anything your calendar has held this year.
          </p>
        </FadeUp>
        <FadeUp delay={0.1}>
          <a
            href="https://www.nseyawellness.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="retreat-cta"
            className="mt-9 inline-flex items-center gap-3 rounded-full border border-gold/50 px-8 py-4 font-mono text-[11px] uppercase tracking-[0.18em] text-gold transition-all duration-300 hover:bg-gold hover:text-ink"
          >
            Visit www.nseyawellness.com →
          </a>
          <p className="mt-4 font-mono text-[9px] uppercase tracking-[0.16em] text-mute/70">
            A separate experience from Elite Therapeutics.
          </p>
        </FadeUp>
      </div>
      <div className="lg:order-1">
        <FadeUp>
          <div className="clip-notch relative overflow-hidden border border-white/10" data-testid="retreat-image">
            <img src="/images/hero.jpeg" alt="The Zanzibar retreat — floating in stillness" loading="lazy"
              className="h-[26rem] lg:h-[34rem] w-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink/85 via-transparent to-ink/20" aria-hidden="true" />
            <div className="glass-chip absolute bottom-5 left-5 right-5 rounded-xl p-5">
              <p className="font-mono text-[9px] uppercase tracking-[0.24em] text-gold">Nseya Wellness · Zanzibar, Tanzania</p>
              <p className="mt-2 font-serif italic text-xl sm:text-2xl text-ivory leading-snug">
                “Six nights to come back to yourself.”
              </p>
            </div>
          </div>
        </FadeUp>
      </div>
    </div>
  </section>
);
